import React from 'react';

export const defaultPrinter = () => {
  return function DefaultPrinter({ item, itemKey }) {
    return <span>{item[itemKey]}</span>;
  };
};
